<template>
  <div id="portotemplate">
    <div class="body">
      <div role="main" class="main">
        <div class="container">
          <v-dialog :clickToClose="false" :pivotY="Number(0.9)" maxHeight="400px"/>
          <router-view :dadosLeilao="dadosLeilao" :dadosModeradorId="dadosModerador"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'portotemplate',
  data() {
    return {
      leilao_id: this.$route.params.id,
      dadosLeilao: [],
      dadosModerador: []
    }
  },
  mounted() {
    this.getDadosLeilao()
  },
  methods: {
    async getDadosLeilao() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const getLeilao = (this.leilao_id) ? `?leilao_id=${this.leilao_id}` : '';

      const dadosLeilao = await fetch(`${hostName}/core/api/get-leiloes${getLeilao}`)
      const leilao = await dadosLeilao.json()
      this.dadosLeilao = (this.leilao_id) ? leilao.items[0] : leilao.items
      await this.getDadosModeradorLeilao()
    },
    async getDadosModeradorLeilao() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const getLeilao = (this.leilao_id) ? `?leilao_id=${this.leilao_id}` : '';

      const dadosLeilao = await fetch(`${hostName}/core/api/get-leiloes-moderador${getLeilao}`);
      this.dadosModerador = await dadosLeilao.json();
      // loop para acompanhar compotamento dos status do leilão
      setTimeout(() => {this.getDadosModeradorLeilao();}, 3000);
    }
  }
}
</script>

<style>

#portotemplate {
  font-family: 'MuseoSans', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue